import { render, staticRenderFns } from "./CreateNewsComment.vue?vue&type=template&id=56d9fd76&scoped=true&"
import script from "./CreateNewsComment.vue?vue&type=script&lang=js&"
export * from "./CreateNewsComment.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewsComment.vue?vue&type=style&index=0&id=56d9fd76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9fd76",
  null
  
)

export default component.exports